export const wordpressURL = 'https://cms.linhardt-art.com/wp-json';